import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import AddIcon from "@mui/icons-material/Add";
import { Button, IconButton, Input, Tooltip, Chip } from "@mui/material";
import { FormControlLabel } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Autocomplete from "@mui/material/Autocomplete";
import useSave from "../../../../Hooks/useSave";
import BasicTable from "../../../../components/InfoDisplay/InfoDisplay";
import Switch from "@mui/material/Switch";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";

function OrderDetail() {
  const { id } = useParams();

  const { fetchGraphql, DialogSave } = useSave();
  const navigate = useNavigate();

  const [customersOptions, setCustomersOptions] = useState([]);
  const [order, setOrder] = useState({});
  const [showMoreInfo, setShowMoreInfo] = useState(false);
  const [products, setProducts] = useState([]);
  const [productsOptions, setProductsOptions] = useState([]);
  const [orderByCode, setOrderByCode] = useState(false);
  const [focus, setFocus] = useState(false);
  const element = useRef();
  const info = useRef()

  useEffect(() => {
    fetchGraphql({
      query: `query Products {
        products {
          productName
          productId
          productCode
          productPrice
        }
      }`,
    }).then((result) => setProductsOptions(result.data.products));

    return () => {};
  }, []);

  useEffect(() => {
    fetchGraphql({
      query: `query Customers {
        customers {
          customerName
          customerId
        }
      }`,
    }).then((result) =>
      setCustomersOptions(
        result.data.customers.map((item) => ({
          ...item,
          label: item.customerName,
        }))
      )
    );

    return () => {};
  }, []);

  useEffect(() => {
    fetchGraphql({
      query: `query Order($orderId: ID!) {
        order(orderId: $orderId) {
          orderId
          orderDate
          packDate
          deliveryDate
          orderedVia
          orderStatus
          createdBy
          lastEditedBy
          customerId
          customerName
          paymentStatus
          orderNote
        }
        orderProducts(orderId: $orderId) {
          orderProductId
          orderId
          productId
          productCode
          productName
          productPrice
          quantity
        }
      }`,
      variables: { orderId: id },
    }).then((result) => {
      // console.log("hi", result);
      setOrder(result.data.order);
      setProducts(result.data.orderProducts);
    });
  }, []);

  useEffect(() => {
    element?.current?.lastChild.firstChild.focus();

    return setFocus(false);
  }, [focus]);

  const date = new Date();
  const tomorow = new Date(date);
  tomorow.setDate(date.getDate() + 1);

  const columns = [
    {
      id: "productCode",
      name: "Product Code",
      edit: !orderByCode,
      customInput: (row, rowIndex, columnIndex) => (
        <Autocomplete
          disablePortal
          key="1"
          // ref={element}
          options={productsOptions.map((item) => ({
            ...item,
            label: item.productCode,
          }))}
          autoSelect={true}
          autoHighlight={true}
          value={row.productCode}
          onChange={(event, value) => {
            // console.log("fired");
            const copyState = [...products];

            copyState[rowIndex] = value || [];

            setProducts(copyState);
          }}
          sx={{ width: 250, marginRight: "10px" }}
          renderInput={(params) => (
            <TextField {...params} ref={element} key="5" label="Product Code" />
          )}
        />
      ),
    },
    {
      id: "productName",
      name: "Product Name",
      edit: orderByCode,
      customInput: (row, index) => (
        <Autocomplete
          ref={element}
          disablePortal
          key="1"
          autoSelect={true}
          autoHighlight={true}
          value={row.productName}
          options={productsOptions.map((item) => ({
            ...item,
            label: item.productName,
          }))}
          onChange={(event, value) => {
            setProducts(
              (products) => {
                const copyState = [...products];

                // console.log(copyState);

                copyState[index] = value;

                return copyState;
              },
              () => console.log(products)
            );
          }}
          sx={{ width: 250, marginRight: "10px" }}
          renderInput={(params) => (
            <TextField
              {...params}
              autofocus={true}
              ref={element}
              key="2"
              label="Product name"
            />
          )}
        />
      ),
    },
    {
      id: "productPrice",
      name: "Price Per Unit",
      edit: false,
    },
    {
      id: "quantity",
      name: "Quantity",
      edit: true,
    },
    {
      id: "totalPrice",
      name: "Total Price",
      edit: false,
    },
  ];

  const options = {
    focusIndex: 2,
    handleEdit: (e, row, columnId, index) => {
      // console.log("handle edit");
      setProducts((rows) => {
        const copyState = [...rows];

        // console.log(Number(e.target.value));

        if (columnId === "orderedQuantity") {
          copyState[index][columnId] = Number(e.target.value);
        } else {
          copyState[index][columnId] = e.target.value;
        }

        return copyState;
      });
    },
    handleDontSave: (originalRow, index) => {
      setProducts((rows) => {
        const copyState = [...rows];

        copyState[index] = originalRow;

        return copyState;
      });
    },
    addRecord: () => {
      setFocus(true);
      setProducts((rows) => [
        ...rows,
        {
          productCode: "",
          productName: "",
          productPrice: "",
          orderedQuantity: "",
          totalPrice: "",
        },
      ]);
    },
    handleDelete: (row, index) =>
      setProducts((rows) => {
        const copyState = [...rows];

        copyState.splice(index, 1);

        return copyState;
      }),
  };

  return (
    <>
      {showMoreInfo ? (
        <>
          <Box
            sx={{
              height: "100%",
              width: "100%",
              top: "0",
              left: "0",
              position: "fixed",
              zIndex: "9999",
              backgroundColor: "rgb(0,0,0,.5)",
            }}
            onClick={() => setShowMoreInfo(!showMoreInfo)}
          ></Box>
          <Paper
            sx={{
              zIndex: "10000",
              position: "fixed",
              right: "2.5%",
              top: "5%",
              bottom: "0",
              height: "fit-content",
              width: "50%",
              // marginTop: "5%"
            }}
          >
            <Tooltip sx={{ display: "flex", marginLeft: "auto" }} title="Close">
              <IconButton onClick={() => setShowMoreInfo(!showMoreInfo)}>
                <CloseIcon />
              </IconButton>
            </Tooltip>
            <Divider />
            <Box
              ref={info}
              sx={{ display: "flex", flexDirection: "row", margin: "10px" }}
            >
              <Box sx={{ margin: "10px", width: "33.33333%" }}>
                <Typography variant="h6">Customer Name</Typography>
                <Typography sx={{ fontStyle: "italic" }}>
                  {order.customerName}
                </Typography>
              </Box>{" "}
              <Box sx={{ margin: "10px", width: "33.33333%" }}>
                <Typography variant="h6">Order Status</Typography>
                <Typography sx={{ fontStyle: "italic" }}>
                  {order.orderStatus}
                </Typography>
              </Box>{" "}
              <Box sx={{ margin: "10px", width: "33.33333%" }}>
                <Typography variant="h6">Payment Status</Typography>
                <Typography sx={{ fontStyle: "italic" }}>
                  {order.paymentStatus}
                </Typography>
              </Box>
            </Box>
            <Divider />
            <Box sx={{ display: "flex", flexDirection: "row", margin: "10px" }}>
              <Box sx={{ margin: "10px", width: "33.33333%" }}>
                <Typography variant="h6">Order Date</Typography>
                <Typography sx={{ fontStyle: "italic" }}>
                  {order.orderDate}
                </Typography>
              </Box>
              <Box sx={{ margin: "10px", width: "33.33333%" }}>
                <Typography variant="h6">Pack Date</Typography>
                <Typography sx={{ fontStyle: "italic" }}>
                  {order.packDate}
                </Typography>
              </Box>
              <Box sx={{ margin: "10px", width: "33.33333%" }}>
                <Typography variant="h6">Delivery Date</Typography>
                <Typography sx={{ fontStyle: "italic" }}>
                  {order.deliveryDate}
                </Typography>
              </Box>
            </Box>
            <Divider />
            <Box sx={{ display: "flex", flexDirection: "row", margin: "10px" }}>
              <Box sx={{ margin: "10px", width: "33.33333%" }}>
                <Typography variant="h6">Ordered Via</Typography>
                <Typography sx={{ fontStyle: "italic" }}>
                  {order.orderedVia}
                </Typography>
              </Box>
              <Box sx={{ margin: "10px", width: "33.33333%" }}>
                <Typography variant="h6">Created By</Typography>
                <Typography sx={{ fontStyle: "italic" }}>
                  {order.createdBy}
                </Typography>
              </Box>{" "}
              <Box sx={{ margin: "10px", width: "33.33333%" }}>
                <Typography variant="h6">Last Edited By</Typography>
                <Typography sx={{ fontStyle: "italic" }}>
                  {order.lastEditedBy}
                </Typography>
              </Box>
            </Box>
          </Paper>
        </>
      ) : null}
      <Box sx={{ height: "100%", overflow: "auto" }}>
        <DialogSave/>
        <Box
          sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
        >
          <Box
            sx={{ display: "flex", flexDirection: "column", marginTop: "10px" }}
          >
            <Autocomplete
              disablePortal
              value={order.customerName || ""}
              autoSelect={true}
              autoHighlight={true}
              options={customersOptions}
              onChange={(event, value) =>
                setOrder({
                  ...order,
                  customerId: value.customerId,
                })
              }
              sx={{ width: 250, marginRight: "10px" }}
              renderInput={(params) => (
                <TextField {...params} key="11" label="Customer Name" />
              )}
            />
          </Box>

          <Box
            sx={{ display: "flex", flexDirection: "column", marginTop: "10px" }}
          >
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                label="Delivery Date"
                openTo="day"
                views={["year", "month", "day"]}
                shouldDisableDate={(date) => {
                  const today = new Date();
                  const todayDate = new Date(date);

                  if (date < today.setDate(today.getDate() - 1)) return true;

                  if (todayDate.getDay() === 6) return true;
                }}
                value={order.deliveryDate || tomorow}
                onChange={(newValue) => {
                  setOrder({ ...order, orderDeliveryDate: newValue });
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </Box>

          {/* <Typography sx={{ marginLeft: "10px" }}>
            Order by product name
          </Typography> */}

          {/* <Typography sx={{ margin: "10px" }}>Order Status</Typography> */}

          <Chip
            sx={{ marginLeft: "10px" }}
            label={order.orderStatus}
            color="secondary"
          />

          <Tooltip sx={{ marginLeft: "auto" }} title="More Info">
            <IconButton onClick={() => setShowMoreInfo(!showMoreInfo)}>
              <InfoIcon />
            </IconButton>
          </Tooltip>
        </Box>

        <TextField
          sx={{ margin: "10px 0px", width: "508px" }}
          multiline
          value={order.orderNote || null}
          onChange={(e) =>
            setOrder({
              ...order,
              orderNote: e.target.value,
            })
          }
          label="Order Note"
          color="primary"
        />

        <Tooltip title={orderByCode ? "Order By Code" : "Order By Product"}>
          <Switch onChange={(e) => setOrderByCode(e.target.checked)} />
        </Tooltip>

        <Box>
          <BasicTable
            columns={columns}
            key="3"
            rows={products.map((item, index) => ({
              ...item,
              totalPrice:
                item.productPrice && item.quantity
                  ? item.productPrice * item.quantity
                  : null,
            }))}
            header="Products"
            options={options}
          />
        </Box>
      </Box>
    </>
  );
}

export default OrderDetail;
